module.exports = __webpack_public_path__ + "54166f742bf8e077890a194809a94df5.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/food/food5.png
// module id = 2571
// module chunks = 0